export default [
    // members sidebar index route
    {
        path: '/community',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/community/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'community.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/community/index.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
